import controller from './gridstack.controller';
import template from './gridstack.html';

export default {
	template,
	bindings: {
		ref: '=',
		options: '<?',
		onReady: '&',
	},
	controller,
	controllerAs: '$ctrl',
};
